const SkipLink = () => {
   return (
      <a
         href="#main-content"
         className="sr-only focus:not-sr-only focus:absolute focus:top-0 focus:left-0 focus:z-50 focus:bg-orgPrimary focus:text-white focus:p-2 focus:rounded-br-md focus:outline-none focus:ring-2 focus:ring-white"
      >
         Skip to main content
      </a>
   );
};

export default SkipLink;
